module.exports = __webpack_public_path__ + "img/icon_no_digitalList.b9cd058a.png";